module.exports = __webpack_public_path__ + "img/your-neurotype.96065624.svg";